export default function KarbonAyakIzi() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold">Karbon Ayak İzi</h1>
      <p className="text-gray-600 mt-2">Sera gazı emisyonları ve karbon ayak izi takibi (Yakında)</p>
    </div>
  );
}
